'use client'
import { ThemeButton } from '@repo/shared/components'
import { CenterBox } from '@repo/ui/components'
import { AuthHeaderLayout } from '@repo/auth/containers'

export const AgentHeaderLayout = () => {
  return (
    <CenterBox className='pt-3xl pb-xs justify-between px-xl'>
      <AuthHeaderLayout isAgent className='!p-0 !m-0' />

      <ThemeButton />
    </CenterBox>
  )
}
